import { Stack } from "@mui/material";
import { FormProvider } from "src/components/hook-form";

import useGetTransferPositions from "../../../../../hooks/useGetTransferPositions";
import AmountValueInput from "./AmountValueInput";
import CustomValueInput from "./CustomValueInput";
import useGetInputsMethods from "./hooks/useGetInputsMethods";

// ----------------------------------------------------------------------

type Props = {
	id: string;
};

export const CustomValueInputsRow = ({ id }: Props) => {
	const { positions } = useGetTransferPositions();

	const position = positions.find((i) => i.positionId === id);

	const { onChangeValue, onChangeShares, methods } = useGetInputsMethods({ id });

	return (
		<FormProvider methods={methods}>
			<Stack flexDirection={"row"} alignItems={"flex-start"} gap={1} sx={{ mt: 1 }}>
				<CustomValueInput id={id} onChangeShares={onChangeShares} />
				<AmountValueInput
					id={id}
					onChangeValue={onChangeValue}
					disabled={!!!position?.amount || position.amount === 0}
				/>
			</Stack>
		</FormProvider>
	);
};

export default CustomValueInputsRow;
